"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ListingServiceContext_1 = require("../service/ListingServiceContext");
var ListModel_1 = require("@twii/core/lib/model/ListModel");
var ListingBookmarkListModel = /** @class */ (function (_super) {
    __extends(ListingBookmarkListModel, _super);
    function ListingBookmarkListModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._addDone = function (bookmark) {
            _this.items.push(bookmark);
            _this.sync.syncEnd();
        };
        _this._addError = function (error) {
            _this.sync.syncError(error);
        };
        _this._removeDone = function (bookmark) {
            var idx = _this._findMatchingIndex(bookmark);
            console.log();
            if (idx >= 0) {
                _this.items.splice(idx, 1);
            }
            _this.sync.syncEnd();
        };
        _this._removeError = function (error) {
            _this.sync.syncError(error);
        };
        return _this;
    }
    ListingBookmarkListModel.prototype._loadImpl = function () {
        return ListingServiceContext_1.ListingServiceContext.value.getBookmarkedListings();
    };
    ListingBookmarkListModel.prototype._findMatchingIndex = function (bookmark) {
        return this.value ? this.value.findIndex(function (item) {
            return item.id === bookmark.id || (item.listing && bookmark.listing ? item.listing.id === bookmark.listing.id : false);
        }) : -1;
    };
    ListingBookmarkListModel.prototype._findMatching = function (bookmark) {
        return this.value ? this.value.find(function (item) {
            return item.id === bookmark.id || (item.listing && bookmark.listing ? item.listing.id === bookmark.listing.id : false);
        }) : undefined;
    };
    ListingBookmarkListModel.prototype.addBookmark = function (bookmark) {
        if (bookmark) {
            var existing = this._findMatching(bookmark);
            if (!existing) {
                this.sync.syncStart({ type: "update", id: String(bookmark.listing.id) });
                return ListingServiceContext_1.ListingServiceContext.value.addBookmark(bookmark).then(this._addDone).catch(this._addError);
            }
            return Promise.resolve();
        }
        return Promise.reject({ code: "INVALID ARGUMENT", message: "No bookmark specified" });
    };
    ListingBookmarkListModel.prototype.removeBookmark = function (bookmark) {
        if (bookmark) {
            var existing = this._findMatching(bookmark);
            if (existing) {
                this.sync.syncStart({ type: "update", id: String(bookmark.listing.id) });
                return ListingServiceContext_1.ListingServiceContext.value.removeBookmark(existing).then(this._removeDone).catch(this._removeError);
            }
            return Promise.resolve();
        }
        return Promise.reject({ code: "INVALID ARGUMENT", message: "No bookmark specified" });
    };
    ListingBookmarkListModel.prototype.getBookmarkForListingId = function (listingId) {
        return this.items ? this.items.find(function (b) { return b.listing && b.listing.id === listingId; }) : undefined;
    };
    __decorate([
        mobx_1.action
    ], ListingBookmarkListModel.prototype, "_addDone", void 0);
    __decorate([
        mobx_1.action
    ], ListingBookmarkListModel.prototype, "_addError", void 0);
    __decorate([
        mobx_1.action
    ], ListingBookmarkListModel.prototype, "addBookmark", null);
    __decorate([
        mobx_1.action
    ], ListingBookmarkListModel.prototype, "_removeDone", void 0);
    __decorate([
        mobx_1.action
    ], ListingBookmarkListModel.prototype, "_removeError", void 0);
    __decorate([
        mobx_1.action
    ], ListingBookmarkListModel.prototype, "removeBookmark", null);
    __decorate([
        mobx_1.action
    ], ListingBookmarkListModel.prototype, "getBookmarkForListingId", null);
    return ListingBookmarkListModel;
}(ListModel_1.ListModel));
exports.ListingBookmarkListModel = ListingBookmarkListModel;
